import { DateRangePicker } from '@src/common/components/dates/DateRangePicker';
import type {
  DateRange,
  SearchPermitFilters,
} from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: DateRange;
}
export const EffectiveDateFilter = ({ onFilterChange, value }: Props) => {
  const { t } = useTranslation();

  return (
    <DateRangePicker
      label={t('permitSearch.effectiveDate')}
      value={{
        from: value?.from ? new Date(value.from) : undefined,
        to: value?.to ? new Date(value.to) : undefined,
      }}
      onChange={(dateRange) => {
        onFilterChange({
          effectiveDate: {
            from: dateRange.from?.toISOString(),
            to: dateRange.to?.toISOString(),
          },
        });
      }}
    />
  );
};
